export const SECTION_NAME_NEW_CAR_LIST = {
  HOVERABLE_MENU: 'hoverable menu',
  LISTING_PAGE: 'listing page',
  INFORMASI_MOBIL_TOYOTA: 'informasi mobil toyota',
  FILTER: 'filter',
  SORT: 'urutkan',
};

export const BUTTON_NAME_NEW_CAR_LIST = {
  RESET_FILTER: 'reset filter',
  LIHAT_DETAIL: 'lihat detail',
  MINTA_PENAWARAN: 'minta penawaran',
  BANDINGKAN: 'bandingkan',
  PESAN_TEST_DRIVE: 'pesan test drive',
  TRADE_IN: 'trade in',
  HUBUNGI_SALES: 'hubungi sales',
  KISARAN_HARGA: 'kisaran harga',
  WARNA: 'warna',
  JENIS_BAHAN_BAKAR: 'jenis bahan bakar',
  TRANSMISI: 'transmisi',
  JUMLAH_TEMPAT_DUDUK: 'jumlah tempat duduk',
  TAG: 'tag',
  SORT: 'urutkan',
  SEARCH: 'search',
  TERAPKAN_FILTER: 'terapkan filter',
};

export const PAGE_NAME_NEW_CAR_LIST = {
  MOBIL_BARU_LISTING_PAGE: 'mobil baru listing page',
};
